















import Vue from 'vue'

import { PriceSettings } from '@/types/price-settings'
 
import modal from '@/components/common/modal/modal.vue'
import editDiscountTable from '@/components/root-components/product-price-setting/edit-discount/edit-discount-table.vue'
import iconButton from '@/components/root-components/product-price-setting/_common/icon-button.vue'

import style from './style.module.scss'

export default Vue.extend({
    name: 'product-price-setting-discount-cell',
    components: {
        modal,
        editDiscountTable,
        iconButton
    },
    props: {
        data: {} as () => PriceSettings,
        typeCode: String
    },
    data() {
        return {
            style: style,
            showDiscountTable: false
        }
    },
    methods: {
        edit(): void {
            this.showDiscountTable = true;
        },
        clear(data: PriceSettings) {
            this.$store.dispatch('deleteDiscountList', data);

            this.$store.dispatch('fill', { typeCode: this.typeCode, row: this.data });
        },
        save(): void {
            this.showDiscountTable = false;

            this.$store.dispatch('fill', { typeCode: this.typeCode, row: this.data });
        }
    },
    computed: {
        precentRange(): string {

            const percents = this.data.Discounts.map((item) => item.Percent).filter((item) => item === 0 ? true : item).sort((a, b) => a && b ? a - b : 0);

            let rangeString = '';

            if(percents.length == 1 && (percents[0] || percents[0] === 0)) {
                rangeString =  `${percents[0]}%`
            }
            else if(percents.length > 1 && (percents[0] || percents[0] === 0) && percents[percents.length - 1]) {
                rangeString = `${percents[0]} – ${percents[percents.length - 1]}%`;
            }

            return rangeString;
        }
    }
})
